import axios from "axios";
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { useSelector, useDispatch } from "react-redux";
import getLoaderActions from "../../actions/LoaderActions";
import getMode from "../../actions/modeActions";
import { allCurrency, getDateFormat, roundOffTwoDecimal } from "../../util";

import "./Analysis.css";
const Analysis = () => {
  const date = getDateFormat(new Date());
  const [coinData, setcoinData] = useState([]);
  const [coinRef, setcoinRef] = useState([]);
  const [currency, setcurrency] = useState("inr");
  const loader = useSelector((state) => state.Loader.state);

  const mode = useSelector((state) => state.mode.payload);

  const dispatch = useDispatch();

  useEffect(() => {
    axios
      .get(
        "https://api.coingecko.com/api/v3/coins/markets?vs_currency=inr&order=market_cap_desc&per_page=100&page=1&sparkline=false"
      )
      .then((response) => {
        setcoinData(response.data);

        dispatch(getLoaderActions("true"));

        dispatch(getMode(localStorage.getItem("mode")));
      });

    return () => {};
         // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const postData = (e) => {
    e.preventDefault();
    let coin = e.target.value;

    axios
      .get(
        `https://api.coingecko.com/api/v3/coins/${coin}/history?date=${date}`
      )
      .then((response) => {
        setcoinRef([response.data]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const postDataCurrency = (e) => {
    setcurrency(e.target.value);
  };

  const data = coinRef.map((item, index) => {
    try {
      return (
        <div
          className={
            mode === "dark"
              ? "darkindividualStatistics"
              : "individualStatistics"
          }
          key={index}
        >
          <img src={item.image.small} alt="Coin Icon"  />
          <h2>{item.name}</h2>
          <div className="socialMedia">
            <span>
              <img src="https://assets.teenvogue.com/photos/56b4f21327a088e24b967bb6/1:1/w_320,c_limit/twitter-gifs.gif" alt="Twitter Logo" />
              <b>Twitter Followers:</b>
              {item.community_data.twitter_followers !== null ? (
                <CountUp
                  end={item.community_data.twitter_followers}
                  duration={2}
                />
              ) : (
                "NA"
              )}
            </span>
            <span>
              <img src="https://cdn.dribbble.com/users/244018/screenshots/1506924/media/a3eb2b9288f8961d6f7d219813d57434.gif" alt="Reddit Logo" />
              <b>Reddit Subscribers:</b>
              {item.community_data.reddit_subscribers !== null ? (
                <CountUp
                  end={item.community_data.reddit_subscribers}
                  duration={2}
                />
              ) : (
                "NA"
              )}
            </span>
          </div>
          <div>
            <h3>Market Data</h3>
            <b>Current Price:</b>
            <p style={{ textTransform: "uppercase" }}>
              {currency}{" "}
              {
                <CountUp
                  end={item.market_data.current_price[currency]}
                  decimals={10}
                  duration={2}
                />
              }
            </p>
            <b>Market Cap:</b>
            <p style={{ textTransform: "uppercase" }}>
              {currency}{" "}
              {
                <CountUp
                  end={roundOffTwoDecimal(
                    item.market_data.market_cap[currency]
                  )}
                  duration={2}
                />
              }
            </p>
            <b>Total Volume:</b>
            <p style={{ textTransform: "uppercase" }}>
              {" "}
              {currency}{" "}
              {
                <CountUp
                  end={roundOffTwoDecimal(
                    item.market_data.total_volume[currency]
                  )}
                  duration={2}
                />
              }
            </p>
          </div>
        </div>
      );
    } catch (error) {
      return (
        <div
          className={
            mode === "dark"
              ? "darkindividualStatistics"
              : "individualStatistics"
          }
        >
          <h3>Site is Under Manitenance. Inconvenience Regreted.</h3>
          <div>
            <br />
            <img
              style={{ borderRadius: "300px", width: "100%" }} alt="MaintenanceImage"
              src="https://i.pinimg.com/originals/44/d9/8c/44d98cccb725fd3a80c0446b9b2e646d.jpg"
            />
          </div>
        </div>
      );
    }
  });
  return (
    <>
      {loader === "false" ? (
        ""
      ) : (
        <div className={mode === "dark" ? "darkanalysis" : "analysis"}>
          <form onSubmit={(e) => e.preventDefault()}>
            <select onChange={postData}>
              <option value="" selected>
                Select
              </option>
              {coinData.map((item, index) => {
                return (
                  <option key={index} value={item.id}>
                    {item.name}{" "}
                  </option>
                );
              })}
            </select>

            <select onChange={postDataCurrency}>
              {allCurrency.map((item, index) => {
                return (
                  <>
                    {currency === item ? (
                      <option
                        key={index}
                        style={{ textTransform: "uppercase" }}
                        value={item}
                        selected
                      >
                        {item}
                      </option>
                    ) : (
                      <option
                        key={index}
                        style={{ textTransform: "uppercase" }}
                        value={item}
                      >
                        {item}
                      </option>
                    )}
                  </>
                );
              })}
            </select>
          </form>
          {data}
        </div>
      )}
    </>
  );
};
export default Analysis;
